import { post } from "helpers/api_helper";
import * as URL from "helpers/url_helper"

export const getCartItem = data => post(URL.GET_CART_ITEM, data);
export const getCartList = data => post(URL.GET_CART_LIST, data);
export const addToCart = data => post(URL.ADD_TO_CART, data);
export const removeFromCart = data => post(URL.REMOVE_FROM_CART, data);
export const updateCart = data => post(URL.UPDATE_CART, data); 
export const emptyCart = data => post(URL.EMPTY_CART, data);